import { useState, useEffect, useCallback } from 'react';
import ClientLayout from '@/components/feature/ClientLayout';
import { useClientProject } from '@/hooks/useClientProject';
import ClientDailyLogEmbed from '@/pages/client/portal/components/ClientDailyLogEmbed';
import { useTranslation } from 'react-i18next';

export default function ClientDailyLog() {
  const { t } = useTranslation();
  const { selectedProject, projectId } = useClientProject();

  return (
    <ClientLayout title="Daily Log">
      <div className="px-4 lg:px-8 pt-5 pb-10">
        {/* Project context */}
        {selectedProject && (
          <div className="mb-5 flex items-center gap-2">
            <div className="w-6 h-6 rounded-lg bg-[#E8621A] flex items-center justify-center flex-shrink-0">
              <i className="ri-building-2-line text-white text-[10px]"></i>
            </div>
            <div>
              <span className="text-[#1A1A1A] text-sm font-bold">{selectedProject.project_name}</span>
              {selectedProject.site_address && (
                <span className="text-[#9CA3AF] text-xs ml-2">{selectedProject.site_address}</span>
              )}
            </div>
          </div>
        )}

        <div className="mb-4">
          <h2 className="text-[15px] font-bold text-[#1A1A1A]">{t('client.dailyLog.siteUpdates')}</h2>
          <p className="text-[#9CA3AF] text-xs mt-0.5">
            {t('client.dailyLog.siteUpdatesDesc')}
          </p>
        </div>

        {/* Info banner */}
        <div className="bg-[#F0FDF4] rounded-2xl p-4 flex items-start gap-3 mb-4">
          <div className="w-8 h-8 rounded-lg bg-[#059669] flex items-center justify-center flex-shrink-0">
            <i className="ri-camera-line text-white text-sm"></i>
          </div>
          <div>
            <p className="text-[#059669] text-sm font-bold">{t('client.dailyLog.dailySiteUpdates')}</p>
            <p className="text-[#374151] text-xs mt-0.5 leading-relaxed">
              {t('client.dailyLog.dailySiteUpdatesDesc')}
            </p>
          </div>
        </div>

        <ClientDailyLogEmbed projectId={projectId} />
      </div>
    </ClientLayout>
  );
}